export default "__VITE_ASSET__c3f2597e__"